import {
  Heading,
  Stat,
  Button,
  Flex,
  Link,
  Table,
  Stack,
  IconButton,
} from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";
import { useSession } from "../../../hooks/useSession";
import { useCustomerGroupList } from "../../../hooks/useCustomerGroup";
import { Pencil } from "lucide-react";

export default function CustomerGroupPage() {
  useSession();

  const { data, isLoading } = useCustomerGroupList();

  return (
    <Stack>
      <Heading as="h1" mb={4}>
        Kundegruppeliste
      </Heading>
      <Stack direction="row">
        <Link asChild>
          <ReactRouterLink to="/customers/groups/create/">
            <Button variant="solid" colorPalette="blue">
              Lag ny gruppe
            </Button>
          </ReactRouterLink>
        </Link>
      </Stack>
      <Flex alignItems="center">
        <Stat.Root my={4}>
          <Stat.Label>Antall kundegrupper</Stat.Label>
          <Stat.ValueText>{data?.length || 0}</Stat.ValueText>
        </Stat.Root>
      </Flex>
      <Table.ScrollArea>
        <Table.Root>
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>Navn</Table.ColumnHeader>
              <Table.ColumnHeader>Antall</Table.ColumnHeader>
              <Table.ColumnHeader>Handlinger</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {!isLoading &&
              data?.map((group) => (
                <Table.Row key={group.uuid}>
                  <Table.Cell>{group.groupName}</Table.Cell>
                  <Table.Cell>{group.customers.length}</Table.Cell>
                  <Table.Cell>
                    <Link asChild>
                      <ReactRouterLink
                        to={`/customers/groups/${group.uuid}/edit/`}
                      >
                        <IconButton
                          size="lg"
                          colorPalette="blue"
                          variant="ghost"
                          aria-label="Endre"
                        >
                          <Pencil />
                        </IconButton>
                      </ReactRouterLink>
                    </Link>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table.Root>
      </Table.ScrollArea>
    </Stack>
  );
}
